"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildInjectToBaseRegisterContainer = buildInjectToBaseRegisterContainer;
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _qs = _interopRequireDefault(require("qs"));
var _reactRedux = require("react-redux");
var _RegisterForm = _interopRequireDefault(require("./RegisterForm"));
var _RegisterWithInlinesActions = require("../RegisterWithInlines/RegisterWithInlinesActions");
var _config = require("../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function buildInjectToBaseRegisterContainer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$form = _ref.form,
    form = _ref$form === void 0 ? _RegisterForm.default : _ref$form,
    _ref$setRoleValueToFo = _ref.setRoleValueToFormData,
    setRoleValueToFormData = _ref$setRoleValueToFo === void 0 ? function (_ref2) {
      var values = _ref2.values;
      return values['role'] ? {
        'user_roles-0-role': values['role']
      } : {};
    } : _ref$setRoleValueToFo,
    redirectAfterRegister = _ref.redirectAfterRegister;
  var componentDidMount = function componentDidMount() {
    _config.INLINE_ROLE_IN_REGISTER && this.props.dispatch({
      type: _RegisterWithInlinesActions.FETCH_ROLES
    });
  };
  return (0, _BaseInjectors.injectToBaseRegisterContainer)(_lodash.default.flowRight((0, _reactRedux.connect)(function (state) {
    return {
      inProgress: state.registerReducer.inProgress,
      roles: _config.INLINE_ROLE_IN_REGISTER && state.registerWithInlinesReducer ? state.registerWithInlinesReducer.roles : null
    };
  })), {
    form: form,
    componentDidMount: componentDidMount,
    handleSubmit: function handleSubmit(values) {
      var next = _qs.default.parse(this.history.location.search, {
        ignoreQueryPrefix: true
      }).next || "".concat(_config.BASE_URL, "app/dashboard");
      this.dispatch({
        type: 'REGISTER_USER',
        data: _objectSpread(_objectSpread({}, values), {}, {
          email: values.email.trim().toLowerCase()
        }, _config.INLINE_ROLE_IN_REGISTER && setRoleValueToFormData({
          values: values,
          roles: this.roles
        })),
        next: next,
        history: this.history,
        redirectTo: redirectAfterRegister ? redirectAfterRegister() : undefined
      });
    }
  });
}
var _default = buildInjectToBaseRegisterContainer();
exports.default = _default;